import React, { Component } from 'react';
import { Switch } from 'react-router';
import { AuthenticatedRoute, UnauthenticatedRoute } from 'components/Route';

/**
 * Import pages and routes
 */

import Home from './Home/Home';
import Lessons from './Lessons/Lessons';
import Inspiration from'./Inspiration/Inspiration';
import DownloadsSnap from'./DownloadsSnap/DowloadsSnap';
import DownloadsProcessing from'./DownloadsProcessing/DowloadsProcessing';
import DownloadsPython from'./DownloadsPython/DowloadsPython';
import DownloadsProgramLanguages from'./DownloadsProgramLanguages/DownloadsProgramLanguages';
import Lesson from'./Lesson/Lesson';
import Questions from'./Questions/Questions';
import LessonEnd from'./LessonEnd/LessonEnd';
import LogIn from'./LogIn/LogIn';
import ForgotPassword from'./ForgotPassword/ForgotPassword';
import Register from'./Register/Register';
import ResetPassword from'./ResetPassword/ResetPassword';
import AccountSettings from'./AccountSettings/AccountSettings';

class Routes extends Component {
    render() {
        return (
            <Switch>
                <AuthenticatedRoute exact path='/' component={Home} />
                <AuthenticatedRoute exact path='/lessen' exact component={Lessons} />
                <AuthenticatedRoute exact path='/inspiratie' component={Inspiration} />
                <AuthenticatedRoute exact path='/downloadssnap' component={DownloadsSnap} />
                <AuthenticatedRoute exact path='/downloadsprocessing' component={DownloadsProcessing} />
                <AuthenticatedRoute exact path='/downloadspython' component={DownloadsPython} />
                <AuthenticatedRoute exact path='/programmeertalen' component={DownloadsProgramLanguages} />
                <AuthenticatedRoute exact path='/les/:lessonId/:step?' component={Lesson} />
                <AuthenticatedRoute exact path='/vragen' component={Questions} />
                <AuthenticatedRoute exact path='/leseinde/:lessonId' component={LessonEnd} />
                <UnauthenticatedRoute exact path='/login' component={LogIn} />
                <UnauthenticatedRoute exact path='/wachtwoordvergeten' component={ForgotPassword} />
                <UnauthenticatedRoute exact path='/aanmelden' component={Register} />
                <UnauthenticatedRoute exact path='/wachtwoord/herstellen' component={ResetPassword} />
                <AuthenticatedRoute exact path='/accountinstellingen' component={AccountSettings} />
            </Switch>
        );
    }
}

export default Routes;


// WEBPACK FOOTER //
// ./resources/assets/screens/Routes.jsx